module.exports = __webpack_public_path__ + "media/images/pages/school-trusts/jonathan-baf129915b03b16881917f901e351c03.jpg";